export default __webpack_public_path__ + "static/media/school-children.9d3b0c64.jpg";